module.exports = __webpack_public_path__ + "img/employees.3c3c92b3.svg";